export default {
  title: 'Low Interview Availability List',
  subTitle: 'This is a list of your recruiters with limited interview availability.',
  tooltipModalHint: 'Click to view a list of recruiters with limited availability',
  modalDescription: '{{count}} recruiters do not have enough interview availabilities to interview candidates.',
  mySchedule: 'View My Availabilities',
  positionsImpacted: 'View Positions Affected',
};
